import { render, staticRenderFns } from "./AlarmDetector.vue?vue&type=template&id=7273c6ca&scoped=true&"
import script from "./AlarmDetector.vue?vue&type=script&lang=js&"
export * from "./AlarmDetector.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDetector.vue?vue&type=style&index=0&id=7273c6ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273c6ca",
  null
  
)

export default component.exports